import { forwardRef } from 'react';

import FilterIcon from 'assets/icons/filter-icon.svg';

import { CustomGlassBox } from './CustomGlassBox';

type FiltersProps = {
  selectedFiltersCount: number;
  onClick: () => void;
};

export const Filters = forwardRef<HTMLButtonElement, FiltersProps>(({ selectedFiltersCount, onClick }, ref) => {
  const hasSelectedFilters = selectedFiltersCount > 0;
  return (
    <>
      <button
        ref={ref}
        type="button"
        onClick={onClick}
        className="tw-relative tw-border-none tw-bg-transparent tw-p-0 tw-outline-none"
      >
        {hasSelectedFilters && (
          <div className="tw-absolute tw-right-[-8px] tw-top-[-8px] tw-z-[1] tw-flex tw-h-[25px] tw-w-[25px] tw-items-center tw-justify-center tw-rounded-full tw-bg-[#2D5EFF] tw-font-jost tw-text-[14px] tw-font-semibold tw-text-white">
            {selectedFiltersCount}
          </div>
        )}
        <CustomGlassBox className="tw-flex tw-h-[50px] tw-w-[50px] tw-cursor-pointer tw-items-center tw-justify-center">
          <img src={FilterIcon} alt="Filter" className="tw-h-5 tw-w-5" />
        </CustomGlassBox>
      </button>
    </>
  );
});

Filters.displayName = 'Filters';
